module.exports = __webpack_public_path__ + "img/aboutus-zh.7259919e.png";